import { render, staticRenderFns } from "./MyBarButton.vue?vue&type=template&id=72037fda&scoped=true&"
import script from "./MyBarButton.vue?vue&type=script&lang=js&"
export * from "./MyBarButton.vue?vue&type=script&lang=js&"
import style0 from "./MyBarButton.vue?vue&type=style&index=0&id=72037fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72037fda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72037fda')) {
      api.createRecord('72037fda', component.options)
    } else {
      api.reload('72037fda', component.options)
    }
    module.hot.accept("./MyBarButton.vue?vue&type=template&id=72037fda&scoped=true&", function () {
      api.rerender('72037fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/components/new/MyBarButton.vue"
export default component.exports